import React from 'react';

function EmptyState({ title, description, action, icon }) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-4 py-16 px-8">
      {icon && (
        <div className="text-neutral-300 mb-2">
          {icon}
        </div>
      )}
      <h3 className="text-h3 text-neutral-700 font-semibold">{title}</h3>
      <p className="text-body text-neutral-500 max-w-xs">{description}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="px-6 py-3 bg-primary-500 text-white text-body font-semibold rounded-md hover:bg-primary-400 active:bg-primary-600 transition-colors duration-fast focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
